var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHello(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.010625 0.391875 2.02125 0.78375 3.0625 1.1875 C11.80069867 6.5791545 15.85047411 13.36846176 18.58203125 23.06640625 C20.07215365 29.95996316 18.55120059 35.62199852 16 42 C15.4121875 43.5159375 15.4121875 43.5159375 14.8125 45.0625 C9.76580506 53.24162629 3.14858951 57.89081221 -5.97265625 60.58203125 C-15.58736883 62.56425523 -24.69575924 59.90705136 -33 55 C-35.875 52.4375 -35.875 52.4375 -38 50 C-38 49.34 -38 48.68 -38 48 C-38.66 48 -39.32 48 -40 48 C-44.67403993 38.02146824 -46.96023533 29.21418564 -43.4375 18.375 C-40.44785826 10.87969251 -34.57253229 3.4841409 -27.0546875 0.1328125 C-17.33912405 -3.6315202 -9.71696329 -3.88678532 0 0 Z ",
    fill: "#FAFAFA",
    transform: "translate(45,3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.57748306 3.78874153 11.40943942 8.76084362 14.2734375 16.66796875 C16.93433829 25.20860192 16.28888651 31.77778373 13 40 C12.608125 41.010625 12.21625 42.02125 11.8125 43.0625 C9.19477901 47.30501332 5.82235587 50.80253034 2 54 C1.34 54 0.68 54 0 54 C0 36.18 0 18.36 0 0 Z ",
    fill: "#0C0C0C",
    transform: "translate(48,5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 17.82 0 35.64 0 54 C-3.57203608 52.21398196 -5.43350965 50.93313183 -8 48 C-8 47.34 -8 46.68 -8 46 C-8.66 46 -9.32 46 -10 46 C-14.67403993 36.02146824 -16.96023533 27.21418564 -13.4375 16.375 C-11.28114248 10.93789853 -8.13588912 7.06871691 -4 3 C-3.18208984 2.14921875 -3.18208984 2.14921875 -2.34765625 1.28125 C-1 0 -1 0 0 0 Z ",
    fill: "#030303",
    transform: "translate(15,5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 9.9 8 19.8 8 30 C5.03 30 2.06 30 -1 30 C-1.02465746 25.8882744 -1.04283959 21.77657722 -1.05493164 17.66479492 C-1.0599708 16.26504772 -1.06680216 14.8653058 -1.07543945 13.46557617 C-1.0875232 11.45754223 -1.09269807 9.44947043 -1.09765625 7.44140625 C-1.10289307 6.23170166 -1.10812988 5.02199707 -1.11352539 3.77563477 C-1 1 -1 1 0 0 Z ",
    fill: "#020202",
    transform: "translate(28,0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 7.59 0 15.18 0 23 C-2.97 23 -5.94 23 -9 23 C-9 15.74 -9 8.48 -9 1 C-6 0 -6 0 0 0 Z ",
    fill: "#020202",
    transform: "translate(36,41)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/HELLO.73150a3760b4d4af4ff7a7a1230b5c09.svg";
export { ForwardRef as ReactComponent };